import { Component, OnInit } from '@angular/core';
import { FermeStateService } from './core/services/entities/ferme-state.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(private fermeState: FermeStateService) {}

  ngOnInit() {
    this.fermeState.load();
  }
}
